/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizersectionname2Inputs */

const en_organizersectionname2 = /** @type {(inputs: Organizersectionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name and handle`)
};

const de_organizersectionname2 = /** @type {(inputs: Organizersectionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name und Kurzname`)
};

/**
* | output |
* | --- |
* | "Name and handle" |
*
* @param {Organizersectionname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizersectionname2 = /** @type {((inputs?: Organizersectionname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizersectionname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizersectionname2(inputs)
	return de_organizersectionname2(inputs)
});
export { organizersectionname2 as "organizerSectionName" }